import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.bubble.css';


// Helper to get grid columns class based on style
function getGridColsClass(style) {
    switch (style) {
        case '2-columns':
            return 'grid-cols-2';
        case '3-columns':
            return 'grid-cols-3';
        case '4-columns':
            return 'grid-cols-4';
        case 'list':
        default:
            return 'flex flex-col gap-3';
    }
}

export default function BlockCards({ block, className, settingsFunnel }) {
    // Fallback cards if none provided

 
    if (block.cards === undefined) {
        block.cards = [
            {
                id: 'card-1',
                imageUrl: "",
                content: "Card description example",
                title: "Card title example",
                button: {
                    text: "Learn More",
                    url: "#",
                    target: null,
                    destinationType: 'step',
                    color: "#ffffff",
                    backgroundColor: "cornflowerblue",
                }
            },
            {
                id: 'card-2',
                imageUrl: "",
                content: "Card description example",
                title: "Card title example",
                button: {
                    text: "Learn More",
                    url: "#",
                    target: null,
                    destinationType: 'step',
                    color: "#ffffff",
                    backgroundColor: "#000000",
                }
            },
        ];
    }

    // Style: 'list', '2-columns', '3-columns', '4-columns'
    const style = block.style || '2-columns';

    // Layout classes
    const gridClass =
        style === 'list'
            ? 'flex flex-col gap-3'
            : `grid gap-3 ${getGridColsClass(style)}`;

    // Sorting logic for order: 'img-content' or 'content-img'
    const order = block.order || 'img-content';

    const handleButtonClick = (buttonUrl) => {
        if (buttonUrl && buttonUrl !== '#') {
            window.open(buttonUrl, '_blank');
        }
    };

 
    return (
            <div className={`rounded-xl   w-full  ${className || ''}`}>
            <div className={gridClass}>
                {block.cards?.map((card) => {
                    // If style is not 'list', use column layout (image on top, content below)
                    if (style !== 'list') {
                        return (
                            <div
                                key={card.id}
                                className={`flex flex-col rounded-lg ${block.showBorder ? 'border border-gray-200' : ''}  transition hover:shadow-md overflow-hidden mb-2`}
                                style={{ minHeight: 200 }}
                            >
                                {/* Image - only show if imageUrl is not null/empty */}
                                {card.imageUrl && (
                                    <div className="flex items-center justify-center w-full overflow-hidden">
                                        <img 
                                            src={card.imageUrl}  
                                            className="w-full h-48 object-cover hover:scale-110 transition-all duration-300" 
                                        />
                                    </div>
                                )}

                                <div className="flex flex-col flex-1 p-0 gap-3">
                                    {/* Description */}
                                    <div className="flex-1">
                                        <div className="text-gray-800" style={{ lineHeight: 1.2 }}>
                                             <ReactQuill
                                              value={card.content}
                                              readOnly={true} 
                                              theme="bubble"
                                              className="p-0 m-0"
                                              style={{color: settingsFunnel.textColor, fontFamily: settingsFunnel.font}}
                                              />
                                        </div>
                                    </div>

                                    {/* Button - only show if button text is not empty */}
                                    {card.button && card.button.text && (
                                        <div className="mt-auto" style={{display: 'none'}}>
                                            <button
                                                onClick={() => handleButtonClick(card.button.url)}
                                                className="w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                                            >
                                                {card.button.text}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    } else {
                        // 'list' style: image/content side by side, with order support
                        return (
                            <div
                                key={card.id}
                                className="flex items-center rounded-lg border border-gray-200 shadow-sm transition hover:shadow-md overflow-hidden"
                                style={{ minHeight: 120 }}
                            >
                                {/* Image first if order is img-content and imageUrl exists */}
                                {order === 'img-content' && card.imageUrl && (
                                    <div className="flex-shrink-0">
                                        <img 
                                            src={card.imageUrl} 
                                             
                                            className="w-24 h-24 object-cover" 
                                        />
                                    </div>
                                )}

                                <div className="flex-1 p-4 flex flex-col gap-2">
                                    <div className="text-gray-800" style={{ lineHeight: 1.2 }}>
                                        <span dangerouslySetInnerHTML={{ __html: card.description }} />
                                    </div>

                                    {/* Button - only show if button text is not empty */}
                                    {card.button && card.button.text && (
                                        <div className="mt-2" style={{display: 'none'}}>
                                            <button
                                                onClick={() => handleButtonClick(card.button.url)}
                                                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors text-sm"
                                            >
                                                {card.button.text}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Image last if order is content-img and imageUrl exists */}
                                {order === 'content-img' && card.imageUrl && (
                                    <div className="flex-shrink-0">
                                        <img 
                                            src={card.imageUrl} 
                                            alt={card.description || "Card image"}
                                            className="w-24 h-24 object-cover" 
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}